export default function GoldTag(props: any) {
    return (
        <svg width="268" height="51" viewBox="0 0 268 51" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g filter="url(#filter0_d_2727_48823)">
                <path d="M264 46.5322L221.875 46.5322L225.996 17.6465L256.675 17.6465L249.673 31.9894L264 46.5322Z" fill="#D9D9D9" />
                <path d="M264 46.5322L221.875 46.5322L225.996 17.6465L256.675 17.6465L249.673 31.9894L264 46.5322Z" fill="url(#paint0_linear_2727_48823)" />
                <path d="M264 46.5322L221.875 46.5322L225.996 17.6465L256.675 17.6465L249.673 31.9894L264 46.5322Z" fill="url(#paint1_linear_2727_48823)" />
                <path d="M264 46.5322L221.875 46.5322L225.996 17.6465L256.675 17.6465L249.673 31.9894L264 46.5322Z" stroke="black" strokeWidth="0.639516" />
                <path
                    d="M264 46.5322L221.875 46.5322L225.996 17.6465L256.675 17.6465L249.673 31.9894L264 46.5322Z"
                    stroke="url(#paint2_linear_2727_48823)"
                    strokeWidth="0.639516"
                />
            </g>
            <g filter="url(#filter1_d_2727_48823)">
                <path d="M3.99994 46.5322L46.125 46.5322L42.0041 17.6465L11.3255 17.6465L18.3271 31.9894L3.99994 46.5322Z" fill="#D9D9D9" />
                <path
                    d="M3.99994 46.5322L46.125 46.5322L42.0041 17.6465L11.3255 17.6465L18.3271 31.9894L3.99994 46.5322Z"
                    fill="url(#paint3_linear_2727_48823)"
                />
                <path
                    d="M3.99994 46.5322L46.125 46.5322L42.0041 17.6465L11.3255 17.6465L18.3271 31.9894L3.99994 46.5322Z"
                    fill="url(#paint4_linear_2727_48823)"
                />
                <path
                    d="M3.99994 46.5322L46.125 46.5322L42.0041 17.6465L11.3255 17.6465L18.3271 31.9894L3.99994 46.5322Z"
                    stroke="black"
                    strokeWidth="0.639516"
                />
                <path
                    d="M3.99994 46.5322L46.125 46.5322L42.0041 17.6465L11.3255 17.6465L18.3271 31.9894L3.99994 46.5322Z"
                    stroke="url(#paint5_linear_2727_48823)"
                    strokeWidth="0.639516"
                />
            </g>
            <g filter="url(#filter2_d_2727_48823)">
                <path d="M46.0969 46.2315L26.2379 35.0984L44.1562 17.3457V17.8192L46.0969 46.2315Z" fill="#D9D9D9" />
                <path d="M46.0969 46.2315L26.2379 35.0984L44.1562 17.3457V17.8192L46.0969 46.2315Z" fill="url(#paint6_linear_2727_48823)" />
                <path d="M46.0969 46.2315L26.2379 35.0984L44.1562 17.3457V17.8192L46.0969 46.2315Z" stroke="black" strokeWidth="0.639516" />
                <path
                    d="M46.0969 46.2315L26.2379 35.0984L44.1562 17.3457V17.8192L46.0969 46.2315Z"
                    stroke="url(#paint7_linear_2727_48823)"
                    strokeWidth="0.639516"
                />
            </g>
            <g filter="url(#filter3_d_2727_48823)">
                <path d="M221.819 46.2315L241.076 34.393L223.759 17.3457V17.8192L221.819 46.2315Z" fill="#D9D9D9" />
                <path d="M221.819 46.2315L241.076 34.393L223.759 17.3457V17.8192L221.819 46.2315Z" fill="url(#paint8_linear_2727_48823)" />
                <path d="M221.819 46.2315L241.076 34.393L223.759 17.3457V17.8192L221.819 46.2315Z" stroke="black" strokeWidth="0.639516" />
                <path
                    d="M221.819 46.2315L241.076 34.393L223.759 17.3457V17.8192L221.819 46.2315Z"
                    stroke="url(#paint9_linear_2727_48823)"
                    strokeWidth="0.639516"
                />
            </g>
            <g filter="url(#filter4_d_2727_48823)">
                <path d="M227.159 2H40.7331L26.1627 34.8894H241.602L227.159 2Z" fill="url(#paint10_linear_2727_48823)" />
                <path d="M227.159 2H40.7331L26.1627 34.8894H241.602L227.159 2Z" stroke="black" strokeWidth="0.639516" />
                <path d="M227.159 2H40.7331L26.1627 34.8894H241.602L227.159 2Z" stroke="url(#paint11_linear_2727_48823)" strokeWidth="0.639516" />
            </g>
            <path
                d="M62.0097 12.7962H71.9297V14.5882H64.4097V17.4682H71.6257V19.2602H64.4097V22.4282H72.0577V24.2202H62.0097V12.7962ZM72.845 15.7402H75.693L77.8691 18.4922L80.0931 15.7402H82.9411L79.3731 19.8522L83.1971 24.2042L80.2531 24.2202L77.8691 21.2122L75.421 24.2202H72.573L76.381 19.8522L72.845 15.7402ZM86.212 16.9562C86.8521 15.9482 88.0841 15.5162 89.4601 15.5162C92.5801 15.5162 94.1 17.7562 94.1 20.0122C94.1 22.3162 92.5641 24.5402 89.4601 24.5402C87.6361 24.5402 86.3561 23.5162 86.212 23.0522H86.18V27.4522H83.972V15.7402H86.18V16.9562H86.212ZM88.916 17.2122C87.1561 17.2122 86.084 18.3002 86.084 20.0122C86.084 21.5802 86.9801 22.8442 88.9321 22.8442C90.9001 22.8442 91.7961 21.6122 91.7961 20.0122C91.7961 18.5082 90.9321 17.2122 88.916 17.2122ZM95.2469 20.0602C95.2469 17.2442 97.3269 15.4202 100.351 15.4202C103.599 15.4202 105.647 17.1962 105.551 20.5402H97.5509C97.6629 21.9962 98.6869 22.9402 100.431 22.9402C101.823 22.9402 102.495 22.4762 102.959 21.7242H105.359C104.463 23.5642 102.847 24.5402 100.495 24.5402C96.7349 24.5402 95.2469 22.3962 95.2469 20.0602ZM97.5509 19.1322H103.247C103.007 17.5002 101.551 16.9242 100.367 16.9242C99.2149 16.9242 97.9029 17.5162 97.5509 19.1322ZM109.306 17.0202C110.058 16.0762 111.178 15.5162 112.65 15.5162C115.434 15.5162 116.25 16.9562 116.25 18.3962V24.2202H114.042V19.1002C114.042 17.8362 113.306 17.2122 111.914 17.2122C110.506 17.2122 109.274 18.0762 109.274 19.6122V24.2202H107.066V15.7402H109.274V17.0202H109.306ZM125.587 12.6042H127.795V24.2202H125.587V23.0522H125.555C125.411 23.5162 124.131 24.5402 122.307 24.5402C119.203 24.5402 117.667 22.3162 117.667 20.0122C117.667 17.7562 119.187 15.5162 122.307 15.5162C123.603 15.5162 124.883 15.9162 125.555 16.9562H125.587V12.6042ZM122.819 17.2122C121.155 17.2122 119.971 18.1882 119.971 20.0122C119.971 21.6122 120.867 22.8442 122.835 22.8442C124.787 22.8442 125.683 21.5802 125.683 20.0122C125.683 18.5082 124.803 17.2122 122.819 17.2122ZM129.645 12.6042H131.853V14.3962H129.645V12.6042ZM129.645 15.7402H131.853V24.2202H129.645V15.7402ZM134.394 13.1162H136.602V15.7402H138.906V17.3402H136.602V21.3562C136.602 22.4442 136.794 22.7162 137.466 22.7162C137.978 22.7162 138.474 22.7002 138.986 22.6842V24.2842C138.394 24.3642 137.962 24.4122 137.29 24.4122C134.81 24.4122 134.394 23.6282 134.394 21.9802V17.3402H132.634V15.7402H134.394V13.1162ZM140.286 12.6042H142.494V14.3962H140.286V12.6042ZM140.286 15.7402H142.494V24.2202H140.286V15.7402ZM143.979 19.9802C143.979 17.5962 145.499 15.4202 149.227 15.4202C152.955 15.4202 154.475 17.5962 154.475 19.9802C154.475 22.3962 152.939 24.5402 149.227 24.5402C145.515 24.5402 143.979 22.3962 143.979 19.9802ZM149.211 17.1162C147.515 17.1162 146.283 18.0922 146.283 19.9802C146.283 21.5642 147.211 22.8442 149.227 22.8442C151.243 22.8442 152.171 21.5642 152.171 19.9802C152.171 18.4282 151.275 17.1162 149.211 17.1162ZM158.134 17.0202C158.886 16.0762 160.006 15.5162 161.478 15.5162C164.262 15.5162 165.078 16.9562 165.078 18.3962V24.2202H162.87V19.1002C162.87 17.8362 162.134 17.2122 160.742 17.2122C159.334 17.2122 158.102 18.0762 158.102 19.6122V24.2202H155.894V15.7402H158.102V17.0202H158.134ZM172.76 12.7962H179.88C181.944 12.7962 183.512 13.8682 183.512 16.3482C183.512 18.4282 182.056 19.8682 179.896 19.8682H175.16V24.2202H172.76V12.7962ZM175.16 18.0762H179.096C180.616 18.0762 181.112 17.4842 181.112 16.3482C181.112 15.2122 180.456 14.5882 179.24 14.5882H175.16V18.0762ZM187.181 17.3882C187.901 16.2522 188.829 15.5162 190.381 15.5162C190.669 15.5162 190.893 15.5322 191.261 15.5962V17.7722C190.717 17.6122 190.333 17.5642 189.869 17.5642C188.301 17.5642 187.149 18.5082 187.149 20.0762V24.2202H184.941V15.7402H187.149V17.3882H187.181ZM191.979 19.9802C191.979 17.5962 193.499 15.4202 197.227 15.4202C200.955 15.4202 202.475 17.5962 202.475 19.9802C202.475 22.3962 200.939 24.5402 197.227 24.5402C193.515 24.5402 191.979 22.3962 191.979 19.9802ZM197.211 17.1162C195.515 17.1162 194.283 18.0922 194.283 19.9802C194.283 21.5642 195.211 22.8442 197.227 22.8442C199.243 22.8442 200.171 21.5642 200.171 19.9802C200.171 18.4282 199.275 17.1162 197.211 17.1162Z"
                fill="black"
            />
            <defs>
                <filter
                    id="filter0_d_2727_48823"
                    x="218.948"
                    y="16.0476"
                    width="48.3737"
                    height="34.6415"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1.27903" />
                    <feGaussianBlur stdDeviation="1.27903" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2727_48823" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2727_48823" result="shape" />
                </filter>
                <filter
                    id="filter1_d_2727_48823"
                    x="0.67802"
                    y="16.0476"
                    width="48.3737"
                    height="34.6415"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1.27903" />
                    <feGaussianBlur stdDeviation="1.27903" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2727_48823" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2727_48823" result="shape" />
                </filter>
                <filter
                    id="filter2_d_2727_48823"
                    x="23.1534"
                    y="15.2996"
                    width="25.8609"
                    height="35.3368"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1.27903" />
                    <feGaussianBlur stdDeviation="1.27903" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2727_48823" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2727_48823" result="shape" />
                </filter>
                <filter
                    id="filter3_d_2727_48823"
                    x="218.899"
                    y="15.303"
                    width="25.2499"
                    height="35.3632"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1.27903" />
                    <feGaussianBlur stdDeviation="1.27903" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2727_48823" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2727_48823" result="shape" />
                </filter>
                <filter
                    id="filter4_d_2727_48823"
                    x="23.1133"
                    y="0.401144"
                    width="221.537"
                    height="38.6449"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1.27903" />
                    <feGaussianBlur stdDeviation="1.27903" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2727_48823" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2727_48823" result="shape" />
                </filter>
                <linearGradient id="paint0_linear_2727_48823" x1="264.429" y1="46.8817" x2="217.205" y2="-61.8719" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFECAA" />
                    <stop offset="1" stopColor="#D89130" />
                </linearGradient>
                <linearGradient id="paint1_linear_2727_48823" x1="111.154" y1="64.4235" x2="508.165" y2="8.08106" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#B48738" />
                    <stop offset="0.02" stopColor="#CAA963" />
                    <stop offset="0.04" stopColor="#DDC587" />
                    <stop offset="0.06" stopColor="#ECDBA3" />
                    <stop offset="0.07" stopColor="#F6EBB7" />
                    <stop offset="0.09" stopColor="#FCF4C3" />
                    <stop offset="0.11" stopColor="#FFF8C7" />
                    <stop offset="0.133665" stopColor="#FEF6C2" />
                    <stop offset="0.177783" stopColor="#FFFCEA" />
                    <stop offset="0.219566" stopColor="#FCF0B3" />
                    <stop offset="0.248951" stopColor="#FAE89C" />
                    <stop offset="0.28" stopColor="#F6DB7C" />
                    <stop offset="0.29" stopColor="#F5D76F" />
                    <stop offset="0.3" stopColor="#F0D06B" />
                    <stop offset="0.383883" stopColor="#D89130" />
                    <stop offset="0.41" stopColor="#B1823A" />
                    <stop offset="0.43" stopColor="#A87733" />
                    <stop offset="0.526116" stopColor="#B0713C" />
                    <stop offset="0.62" stopColor="#AE7B33" />
                    <stop offset="0.69" stopColor="#D69D48" />
                    <stop offset="0.71" stopColor="#C18D41" />
                    <stop offset="0.79" stopColor="#6E4B25" />
                    <stop offset="0.82" stopColor="#4E321A" />
                    <stop offset="0.9" stopColor="#7B521F" />
                    <stop offset="0.93" stopColor="#8D5F22" />
                    <stop offset="1" stopColor="#D69D48" />
                </linearGradient>
                <linearGradient id="paint2_linear_2727_48823" x1="266.71" y1="48.6359" x2="233.459" y2="-29.0465" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D89130" />
                    <stop offset="1" stopColor="#FFECAA" />
                </linearGradient>
                <linearGradient id="paint3_linear_2727_48823" x1="3.57065" y1="46.8817" x2="50.7954" y2="-61.8719" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFECAA" />
                    <stop offset="1" stopColor="#D89130" />
                </linearGradient>
                <linearGradient id="paint4_linear_2727_48823" x1="156.846" y1="64.4235" x2="-240.165" y2="8.08106" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#B48738" />
                    <stop offset="0.02" stopColor="#CAA963" />
                    <stop offset="0.04" stopColor="#DDC587" />
                    <stop offset="0.06" stopColor="#ECDBA3" />
                    <stop offset="0.07" stopColor="#F6EBB7" />
                    <stop offset="0.09" stopColor="#FCF4C3" />
                    <stop offset="0.11" stopColor="#FFF8C7" />
                    <stop offset="0.133665" stopColor="#FEF6C2" />
                    <stop offset="0.177783" stopColor="#FFFCEA" />
                    <stop offset="0.219566" stopColor="#FCF0B3" />
                    <stop offset="0.248951" stopColor="#FAE89C" />
                    <stop offset="0.28" stopColor="#F6DB7C" />
                    <stop offset="0.29" stopColor="#F5D76F" />
                    <stop offset="0.3" stopColor="#F0D06B" />
                    <stop offset="0.383883" stopColor="#D89130" />
                    <stop offset="0.41" stopColor="#B1823A" />
                    <stop offset="0.43" stopColor="#A87733" />
                    <stop offset="0.526116" stopColor="#B0713C" />
                    <stop offset="0.62" stopColor="#AE7B33" />
                    <stop offset="0.69" stopColor="#D69D48" />
                    <stop offset="0.71" stopColor="#C18D41" />
                    <stop offset="0.79" stopColor="#6E4B25" />
                    <stop offset="0.82" stopColor="#4E321A" />
                    <stop offset="0.9" stopColor="#7B521F" />
                    <stop offset="0.93" stopColor="#8D5F22" />
                    <stop offset="1" stopColor="#D69D48" />
                </linearGradient>
                <linearGradient id="paint5_linear_2727_48823" x1="1.28974" y1="48.6359" x2="34.5409" y2="-29.0465" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D89130" />
                    <stop offset="1" stopColor="#FFECAA" />
                </linearGradient>
                <linearGradient id="paint6_linear_2727_48823" x1="46.4938" y1="46.754" x2="31.6349" y2="33.0466" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFECAA" />
                    <stop offset="1" stopColor="#CD7D0F" />
                </linearGradient>
                <linearGradient id="paint7_linear_2727_48823" x1="156.453" y1="6.51959" x2="126.195" y2="75.357" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D89130" />
                    <stop offset="1" stopColor="#FFECAA" />
                </linearGradient>
                <linearGradient id="paint8_linear_2727_48823" x1="221.422" y1="46.754" x2="236.28" y2="33.0466" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFECAA" />
                    <stop offset="1" stopColor="#CD7D0F" />
                </linearGradient>
                <linearGradient id="paint9_linear_2727_48823" x1="111.462" y1="6.51959" x2="141.72" y2="75.357" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D89130" />
                    <stop offset="1" stopColor="#FFECAA" />
                </linearGradient>
                <linearGradient id="paint10_linear_2727_48823" x1="15.9992" y1="-17" x2="603.218" y2="92.509" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#B48738" />
                    <stop offset="0.02" stopColor="#CAA963" />
                    <stop offset="0.04" stopColor="#DDC587" />
                    <stop offset="0.06" stopColor="#ECDBA3" />
                    <stop offset="0.07" stopColor="#F6EBB7" />
                    <stop offset="0.09" stopColor="#FCF4C3" />
                    <stop offset="0.11" stopColor="#FFF8C7" />
                    <stop offset="0.133665" stopColor="#FEF6C2" />
                    <stop offset="0.177783" stopColor="#FFFCEA" />
                    <stop offset="0.219566" stopColor="#FCF0B3" />
                    <stop offset="0.248951" stopColor="#FAE89C" />
                    <stop offset="0.28" stopColor="#F6DB7C" />
                    <stop offset="0.29" stopColor="#F5D76F" />
                    <stop offset="0.3" stopColor="#F0D06B" />
                    <stop offset="0.383883" stopColor="#D89130" />
                    <stop offset="0.41" stopColor="#B1823A" />
                    <stop offset="0.43" stopColor="#A87733" />
                    <stop offset="0.526116" stopColor="#B0713C" />
                    <stop offset="0.62" stopColor="#AE7B33" />
                    <stop offset="0.69" stopColor="#D69D48" />
                    <stop offset="0.71" stopColor="#C18D41" />
                    <stop offset="0.79" stopColor="#6E4B25" />
                    <stop offset="0.82" stopColor="#4E321A" />
                    <stop offset="0.9" stopColor="#7B521F" />
                    <stop offset="0.93" stopColor="#8D5F22" />
                    <stop offset="1" stopColor="#D69D48" />
                </linearGradient>
                <linearGradient id="paint11_linear_2727_48823" x1="232.726" y1="0.0266477" x2="200.959" y2="92.5154" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D89130" />
                    <stop offset="1" stopColor="#FFECAA" />
                </linearGradient>
            </defs>
        </svg>
    );
    {
    }
}
